(function () {
  'use strict';
  if (window.GLConsultPrivacy) return;
  var key = 'gl_attribution';
  var listeners = [];
  var previous = '';
  var allowedKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'campaign_id', 'adset_id', 'ad_id', 'fbclid', 'gclid'];
  function read() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    function allowed(method) {
      try { return !!privacy && typeof privacy[method] === 'function' && privacy[method]() === true; } catch (_) { return false; }
    }
    return { version: 1, source: 'shopify_customer_privacy', analytics: allowed('analyticsProcessingAllowed'), marketing: allowed('marketingAllowed'), saleOfData: allowed('saleOfDataAllowed') && navigator.globalPrivacyControl !== true };
  }
  function marketingAllowed() { var c = read(); return c.marketing && c.saleOfData; }
  function privacyKnown() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    return !!api && ['analyticsProcessingAllowed', 'marketingAllowed', 'saleOfDataAllowed'].every(function (method) { return typeof api[method] === 'function'; });
  }
  function clean(value, limit) {
    return typeof value === 'string' && value.length <= (limit || 160) && /^[a-zA-Z0-9 _.,~+:%\/-]+$/.test(value) && !/@|%40|https?:/i.test(value) ? value : '';
  }
  function attribution() {
    if (!marketingAllowed()) return {};
    try {
      var stored = JSON.parse(localStorage.getItem(key) || '{}');
      var result = {};
      ['first', 'last'].forEach(function (touch) {
        var item = stored[touch];
        if (!item || !Number.isFinite(item.ts) || item.ts > Date.now() || Date.now() - item.ts > 90 * 86400000) return;
        var safe = { ts: item.ts };
        allowedKeys.forEach(function (k) { var v = clean(item[k], 200); if (v) safe[k] = v; });
        if (typeof item.landing_page === 'string' && /^\/[a-zA-Z0-9_\/-]*$/.test(item.landing_page)) safe.landing_page = item.landing_page;
        result[touch] = safe;
      });
      return result;
    } catch (_) { return {}; }
  }
  function capture() {
    if (!marketingAllowed()) {
      if (privacyKnown() || navigator.globalPrivacyControl === true) {
        try { localStorage.removeItem(key); sessionStorage.removeItem('gl_identified_sent'); } catch (_) {}
      }
      return;
    }
    try {
      var query = new URLSearchParams(location.search);
      var found = {};
      allowedKeys.forEach(function (k) { var value = clean(query.get(k), 200); if (value) found[k] = value; });
      if (!Object.keys(found).length) return;
      found.ts = Date.now();
      found.landing_page = /^\/[a-zA-Z0-9_\/-]*$/.test(location.pathname) ? location.pathname : '/';
      var stored = attribution();
      stored.last = found;
      if (!stored.first) stored.first = found;
      localStorage.setItem(key, JSON.stringify(stored));
    } catch (_) {}
  }
  function notify() {
    capture();
    var current = read();
    var signature = JSON.stringify(current);
    if (signature === previous) return;
    previous = signature;
    listeners.slice().forEach(function (listener) { try { listener(current); } catch (_) {} });
    document.dispatchEvent(new CustomEvent('gl:privacy_changed', { detail: current }));
  }
  window.GLConsultPrivacy = {
    read: read,
    marketingAllowed: marketingAllowed,
    attribution: attribution,
    clean: clean,
    subscribe: function (listener) { listeners.push(listener); try { listener(read()); } catch (_) {} },
    refresh: notify
  };
  window.glReadAttribution = attribution;
  document.addEventListener('visitorConsentCollected', notify);
  window.addEventListener('pageshow', notify);
  notify();
  var attempts = 0;
  function load() {
    attempts++;
    if (window.Shopify && window.Shopify.customerPrivacy) { notify(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) notify();
        else if (attempts < 10) setTimeout(load, 1000);
      });
    } else if (attempts < 10) setTimeout(load, 1000);
  }
  try { load(); } catch (_) {}
})();
